import { GraphQuery } from 'dashboard/models/graph-query';
import { GraphQueryActions, GraphQueryActionType } from 'dashboard/redux/actions/graph-query';

export interface GraphQueryState {
  graphQuery: GraphQuery | undefined;
}

const initialState: GraphQueryState = {
  graphQuery: undefined,
};

export default (state: GraphQueryState = initialState, action: GraphQueryActions) => {
  switch (action.type) {
    case GraphQueryActionType.SetGraphQuery: {
      return {
        ...state,
        graphQuery: action.payload.graphQuery,
      };
    }

    case GraphQueryActionType.ClearGraphQuery: {
      return {
        ...state,
        graphQuery: null,
      };
    }

    default:
      return state;
  }
};
